import React from "react";
import ConditionsSummary from "./ConditonsSummary";

function ConditionTable(props) {
    const [viewRaw, setViewRaw] = React.useState(false)
    const handleToggleRaw = () => {
        setViewRaw(!viewRaw);
    }

    // DOM Render =====================================================================================
    return(
        <div className="mt-3 mb-4">
            <div className="x-divider mb-4"></div>
                <div key={Math.floor(Math.random() * 100000)} className="m-3 mobile-mx-0 bg-blue-50 p-2 sm:p-4 rounded-xl">
                    <h3 className="font-bold mb-4">{props.buoyName} (ID: {props.buoyID})</h3>

                    <ConditionsSummary 
                        key={Math.floor(Math.random() * 1000000000)}
                        summary={props.meteorological.summary}
                    />

                    <button className="btn-primary mt-4" onClick={handleToggleRaw}>{viewRaw ? 'Hide Raw Data' : 'Show Raw Data'}</button>

                    <div className={viewRaw ? '' : 'hidden'}>
                        <h3 className="m-3 font-bold">Meteorological Data</h3>
                        {!props.meteorological.error ? <div className="mobile-scroll">
                            <table className="">
                                <thead>
                                    <tr>
                                        {props.meteorological.headers.map(header => <th key={header}>{header}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.meteorological.data.map((dataSet) => {
                                        return (
                                            <tr key={Math.floor(Math.random() * 100000)}>
                                                {dataSet.map((item) => <td key={`${Math.floor(Math.random() * 100000)}`}>{item}</td>)}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div> : <p className="error">{props.meteorological.data}</p>}

                        <h3 className="mb-3 mt-6 sm:mt-10 font-bold">Spectral Data</h3>
                        {!props.spectral.error ? <div className=" mobile-scroll">
                            <table>
                                <thead>
                                    <tr>
                                        {props.spectral.headers.map(header => <th key={header}>{header}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.spectral.data.map((dataSet) => {
                                        return (
                                            <tr key={Math.floor(Math.random() * 100000)}>
                                                {dataSet.map((item) => <td key={`${Math.floor(Math.random() * 100000)}`}>{item}</td>)}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div> : <p className="error">{props.spectral.data}</p>}
                    </div>
                </div>
            {props.notes && <div className="notebook"><p className="">{props.notes}</p></div>}
        </div>
    )

}

export default ConditionTable;